// import React, { useState, useEffect } from "react";

// const steps = [
//   "Scanning market data",
//   "Matching buyer profiles",
//   "Ranking high-intent leads",
//   "Preparing best results",
// ];

// const SmoothStepLoader = () => {
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setIndex((i) => (i + 1) % steps.length);
//     }, 1200);
//     return () => clearInterval(interval);
//   }, []);

//   return (
//     <div className="w-full max-w-xs p-4 rounded-xl dark:bg-gray-800">
//       <p className="text-sm font-medium text-gray-800 dark:text-gray-200 mb-2">
//         {steps[index]}
//       </p>

//       <div className="relative h-2 bg-gray-200 rounded-full overflow-hidden">
//         <div
//           className="absolute top-0 left-0 h-full bg-blue-600 transition-all duration-700"
//           style={{ width: `${((index + 1) / steps.length) * 100}%` }}
//         ></div>
//       </div>
//     </div>
//   );
// };

// export default SmoothStepLoader;

import React, { useState, useEffect } from "react";

const steps = [
  "Scanning market data",
  "Matching buyer profiles",
  "Ranking high-intent leads",
  "Preparing best results",
];

const SmoothStepLoader = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((i) => (i + 1) % steps.length);
    }, 1400);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full max-w-md p-4 max-md:p-2 rounded-2xl  dark:bg-gray-800/60 backdrop-blur-xl border border-white/20 dark:border-gray-700/30">
      {/* Step Text */}
      <div className="flex items-center gap-2 mb-3">
        <div className="flex gap-1">
          <span className={`w-2 h-2  max-md:w-1 max-md:h-1 rounded-full bg-blue-600 animate-pulse`} />
          <span
            className={`w-2 h-2  max-md:w-1 max-md:h-1 rounded-full bg-blue-600/70 animate-pulse delay-150`}
          />
          <span
            className={`w-2 h-2  max-md:w-1 max-md:h-1 rounded-full bg-blue-600/50 animate-pulse delay-300`}
          />
        </div>

        <p className="text-sm font-semibold text-gray-800 dark:text-gray-100 tracking-wide">
          {steps[index]}
        </p>
      </div>

      {/* Progress Bar */}
      <div className="relative h-2 max-md:h-1.5 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full 
            bg-gradient-to-r from-blue-500 via-violet-500 to-blue-800 
            rounded-full shadow-[0_0_12px_rgba(99,102,241,0.6)]
            transition-all duration-700 ease-out"
          style={{ width: `${((index + 1) / steps.length) * 100}%` }}
        ></div>
      </div>
    </div>
  );
};

export default SmoothStepLoader;
